import { Button } from "@svea/design-system-components-react";
import { ButtonGroup, Dialog, Markdown, useText } from "@sveabank/cc-common";
import type React from "react";

type Props = {
	isOpen: boolean;
	onClose: () => void;
};

const PackageSuccessModal: React.FC<Props> = ({ isOpen, onClose }) => {
	const [t, texts] = useText();
	return (
		<Dialog
			isOpen={isOpen}
			isDismissable={false}
			center
			size="small"
			heading={t(texts.signPage.agreementSuccessModal.title)}
			icon="success"
		>
			<Dialog.Content>
				<Markdown allowParagraphs>
					{t(texts.signPage.agreementSuccessModal.descriptionPackage)}
				</Markdown>
			</Dialog.Content>
			<Dialog.Footer>
				<ButtonGroup>
					<Button onPress={onClose} width="full">
						{t(texts.common.continue)}
					</Button>
				</ButtonGroup>
			</Dialog.Footer>
		</Dialog>
	);
};
export default PackageSuccessModal;
